import { render } from "./userCardiovascularView.vue?vue&type=template&id=332589c3&scoped=true"
import script from "./userCardiovascularView.vue?vue&type=script&lang=js"
export * from "./userCardiovascularView.vue?vue&type=script&lang=js"

import "./userCardiovascularView.vue?vue&type=style&index=0&id=332589c3&lang=less&scoped=true"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332589c3"]])

export default __exports__